/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxProgressFull = require('sdx/progress/ProgressFull').default;

(function ($) {
	"use strict";
	/*globals Tc */

	/**
	 * FormStepIndicator module implementation.
	 *
	 * @author Thomas Junghans
	 * @namespace Tc.Module
	 * @class FormStepIndicator
	 * @extends Tc.Module
	 */
	Tc.Module.FormStepIndicator = Tc.Module.extend({

		/**
		 * Initializes the FormStepIndicator module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {
			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		MAXIMUM_MARKERS: 5,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				markerCount,
				containerWidth,
				connectorWidth,
				currentPosition,
				markerWidth,
				leftOffset,
				extendedConnectorWidth;

			mod.$marker = $ctx.find('div.marker');
			mod.$markerConnector = $ctx.find('div.marker-connector');

			markerCount = mod.$marker.length;
			containerWidth = $ctx.width();
			connectorWidth = mod.$markerConnector.filter(':first').width();
			currentPosition = $ctx.find('div.marker-active').filter(':last').index();

			markerWidth = mod.$marker.filter(':first').width();

			// Ignore 1 and maximum
			if (markerCount < mod.MAXIMUM_MARKERS && markerCount > 1) {
				leftOffset = (containerWidth - (markerCount * markerWidth)) / (markerCount - 1);
				extendedConnectorWidth = connectorWidth + leftOffset;

				mod.$markerConnector.width(extendedConnectorWidth);
				mod.$marker.not(':first').css('margin-left', leftOffset);
			}

			mod.setStepByIndex(currentPosition);

			// The link default action is not needed. Theoretically, if JavaScript would be deactivated, the step would be opened
			$ctx.on('click', 'a.marker-label', function (event) {
				event.preventDefault();
			});

			if (mod.$ctx.hasClass('progress-full')) {
				mod.progressFull = new SdxProgressFull(mod.$ctx[0]);
				mod.$ctx.find('button.indicator').attr('disabled', true);
			}

			callback();
		},

		setStepByIndex: function (index) {

			var mod = this,
				counter = index;

			mod.$marker.removeClass('marker-active finish finish-all');

			while (counter >= 0) {
				mod.$marker.eq(counter).addClass('marker-active').removeClass('finish');
				counter -= 1;
			}

			mod.setFinishStep(index);

			if (mod.progressFull) {
				mod.progressFull.value = index + 1;
			}

		},

		setFinishStep: function (index) {

			var mod = this,
				activeCount = mod.$ctx.find('.marker-active').length,
				totalCount = mod.$ctx.find('.marker-container').children().length;

			// If the same step with container (div)
			if (totalCount === activeCount) {
				mod.$ctx.find('.marker').last().addClass('finish-all').removeClass('.marker-active finish');
			}

			mod.$ctx.find('.marker-active').addClass('finish');
			mod.$ctx.find('.marker-active').last().removeClass('finish');
		},

		onStepChange: function (data) {
			if (isNaN(data.stepIndex)) {
				this.setStepByIndex(0);

			} else {
				this.setStepByIndex(data.stepIndex);
			}
		}
	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.FormStepIndicator.js
// module id = 277
// module chunks = 0